<template>
    <div class="card">
        <div class="card-header">
           <button
          id="filterCollapse"
          :class="arrow === 0 ? 'btn btn-filter' : 'btn btn-filter active' "
          type="button"
          data-toggle="collapse"
          data-target="#collapseFilter"
          aria-expanded="false"
          aria-controls="collapseFilter"
          @click="arrowChanger"
        >
        <span style="color:#414141">
          Filters <i :class="arrow === 0 ? 'ml-2 fa fa-caret-down' : 'ml-2 fa fa-caret-up' "  aria-hidden="true" ></i>
        </span>
        </button>
            <div class="collapse show" id="collapseFilter">
                <div class="row">
                    <div class="col-lg-2">
                        <select class="select-filter" name="limitFilter" id="limitFilter" v-model="limitFilter">
                            <option selected disabled>Show </option>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                        </select>
                        <div class="select-filter-icon">
                            <i class="fa fa-th-list" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>



            </div>
        </div>
        <div class="card-body">
            <div class="col-lg-2 float-right mb-5">
                <input class="input-filter" id="nameFilter" v-model="searchGlobal" name="nameFilter" type="text"
                    placeholder="Search..." />
                <div class="input-filter-icon">
                    <i class="fa fa-search mr-2"></i><span style="font-size:12px"></span>
                </div>
            </div>

            <div class="pull-left resetFilter">
                <button class="btn btn-secondary btn-sm btn-circle y pull-left" @click="resetFilter" id="resetFilter">
                    <i id="resetIcon" class="now-ui-icons arrows-1_refresh-69" aria-hidden="true"
                        style="font-size: 15px"></i>
                </button>
            </div>
            <div class="table-responsive">
                <!-- <Loading /> -->
                <table id="table_order" class="table table-condensed text-center table-hover table-loader" width="100%">
                    <thead class="">
                        <tr class="table-condensed text-uppercase text-muted text-sm-center">
                            <th id="filterSort" class="filterSort" v-for="col in column"
                                @click="col.value == '' ? sort('') :sort(col.value)" :key="col.name"
                                style="cursor: pointer;">
                                {{ col.name }}
                                <template v-if="col.isOrder">
                                    <template v-if="col.order === ''">
                                        <i class="up-icon" />
                                        <i class="down-icon" />
                                    </template>
                                    <template v-else>
                                        <i :class="[col.order === 'asc' ? 'up-icon' : 'down-icon']" />
                                    </template>
                                </template>
                                <!-- <i v-if="col.isOrder" style="font-size:9px"
                    :class="[col.order === 'asc' ? 'fas fa-arrow-up' : 'fas fa-arrow-down']"/> -->

                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(kl,index) in penagihanData" :key="index">
                            <td>{{kl.no}}</td>
                            <td>{{kl.invoice}}</td>
                            <td>{{kl.customerName}}</td>
                            <td>{{kl.billingDate}}</td>
                            <td>{{kl.paymentDate}}</td>
                            <td>{{kl.createdAt}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row">
                <div class="col">
                    <p class="text-muted mt-1 ml-4 pull-left">Showing {{penagihanPagination.from}} to
                        {{penagihanPagination.to}} of
                        {{penagihanPagination.total}} entries</p>
                </div>
                <div class="col">
                    <pagination :data="penagihanPagination" :showDisabled="showDisabled" @pagination-change-page="getResult" :align="align" :limit="limit"></pagination>
                    
                </div>

            </div>
        </div>
    </div>
</template>

<style>
    .modal-content {
        background-color: rgb(245, 245, 245);
    }
</style>

<script>
    import Vue from "vue";
    // import Loading from "/src/components/loader/Loading.vue";
    import axios from "axios";
    import $ from "jquery";
    Vue.component("pagination", require("laravel-vue-pagination"));

    // import { sleeper } from "/src/utils/sleeper.js";

    export default {
        components: {
            // Loading
        },
        data() {
            return {
                penagihanData: {},
                penagihanPagination: {},
                parentData: {},
                column: {},
                limit: 3,
                currentSort: "",
                currentSortDir: "asc",
                limitFilter: 10,
                showDisabled: true,
                searchGlobal: '',
                // size: "default",
                align: "right",
                arrow:0
            };
        },
        watch: {
            limitFilter() {
                this.getResult(1)
            },
            statusFilter() {
                this.getResult(1)
            },
            currentSortDir() {
                this.getResult(1);
            },
            searchGlobal(){
               this.getResult(1)
            }
        },
        created() {
            this.getResult(1)
        },
        methods: {
            getResult(page) {
                $('table').addClass('table-loading')
                const params =
                    `?page=${page}&limit=${this.limitFilter}&sort=${this.currentSort+'-'+this.currentSortDir}&search=${this.searchGlobal}`
                const allBillingUrl = `seller/order/billing${params}`;
                axios
                    .get(allBillingUrl)
                    .then((response) => {
                         $('table').removeClass('table-loading')
                          $("table").removeClass("table-loader");
                        return response.data.data;
                    })
                    .then((data) => {
                        const allBillingData = data.items;
                        this.penagihanData = allBillingData;
                        this.parentData = data
                        this.column = data.column
                        this.penagihanPagination = {
                            current_page: page,
                            data: allBillingData,
                            from: data.from,
                            last_page: data.lastPage,
                            next_page_url: data.nextPage,
                            per_page: data.perPage,
                            prev_page_url: data.prevPageUrl,
                            to: data.to,
                            total: data.total,
                        };
                    });
            },
            sort(colValue) {
                // if you click the same label twice
                $('#filterSort').trigger("click");
                if (this.currentSort === colValue) {
                    this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
                } else {
                    $('#filterSort').trigger("click");
                    this.currentSort = colValue;
                }
            },
            resetFilter(){
                Object.assign(
                    (this.limitFilter = 10),
                    (this.currentSort = ""),
                    (this.currentSortDir = ""),
                    (this.searchGlobal = '')
                )
                $("#resetIcon").addClass("spin");
                setTimeout(function () {
                    $("#resetIcon").removeClass("spin");
                }, 500);
            },
             arrowChanger(){
                if(this.arrow === 0){
                    this.arrow = 1
                    $('#filterCollapse').addClass('active')
                } else {
                    this.arrow = 0
                    $('#filterCollapse').addClass('')
                }
            },
        },
    };
</script>


<style scoped>
.select-filter {
  width: 100%;
  height: 35px;
  cursor: pointer;
  border-radius: 0;
  font-size: 13px;
  background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png)
    no-repeat right #ddd;
  background-size: 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #818181;
  color: #464545;
  padding: 0px 0px 0px 30px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Adding transition effect */
  transition: color 0.3s ease, background-color 0.3s ease,
    border-bottom-color 0.3s ease;
} /* For IE <= 11 */
.select-filter::-ms-expand {
  display: none;
}

select option {
  /* margin: 40px; */
  background-color: #fff;
  color: #fff;
  /* text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4); */
}

.input-filter {
    width: 100%;
    height: 35px;
    cursor: pointer;
    border-radius: 0;
    font-size: 13px;
    background-size: 10px;
    background-color: transparent;
    border: none;
    border-bottom: 0.3px solid #818181;
    /* color: #464545; */
    padding: 0px 0px 0px 40px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    /* Adding transition effect */
    transition: color 0.3s ease, background-color 0.3s ease,
      border-bottom-color 0.3s ease;
  }



  .input-filter::-ms-expand {
    display: none;
  }


  .input-filter-icon {
    position: absolute;
    top: 5px;
    left: 20px;
    width: 100%;
    /* height: 36px; */
    pointer-events: none;
    /* border: 2px solid #353535; */
    padding-left: 5px;
    transition: background-color 0.3s ease, border-color 0.3s ease;
  }

  .input-filter-icon svg.icon {
    transition: fill 0.3s ease;
    fill: rgb(51, 51, 51);
  }

.select-filter-icon {
  position: absolute;
  top: 8px;
  left: 10px;
  width: 30px;
  height: 36px;
  pointer-events: none;
  /* border: 2px solid #353535; */
  padding-left: 5px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
.select-filter-icon svg.icon {
  transition: fill 0.3s ease;
  fill: rgb(51, 51, 51);
}

.select-filter:hover ~ .select-filter-icon,
.select-filter:focus ~ .select-filter-icon {
  background-color: white;
  /* border-color: #464545; */
}


  
</style>